import {createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles';

import * as types from '../constants/types';
import {fetchArticles} from '../articles/actions';
import {verify} from '../auth/actions';

export const loadApp = () => async dispatch => {
	await Promise.all([dispatch(fetchArticles()), dispatch(verify())]);

	dispatch({
		type: types.app.LOADING,
	});
};

export const notFound = () => ({type: types.app.NOT_FOUND});

export const changeTheme = theme => ({
	type: types.app.CHANGE_THEME,
	payload: {
		theme: responsiveFontSizes(
			createMuiTheme({
				palette: {
					...theme,
				},
			}),
		),
	},
});
